import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

import ScrollToTop from "../../components/ScrollTop";
import DownloadApp from "../home/DownloadApp";

import Breadcrumb from "../../components/Breadcrumb";
import RegisterMain from "./RegisterMain";

const Register= () => {
  return (
    <>
      <Header parentMenu="contact" menuCategoryEnable="enable" />

      <div className="react-wrapper">
        <div className="react-wrapper-inner">
          <Breadcrumb pageTitle="Register" />

          <RegisterMain/>

          {/* download-app-start */}
          <DownloadApp />
          {/* download-app-end */}

          {/* scrolltop-start */}
          <ScrollToTop />
          {/* scrolltop-end */}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Register;
